import { render, staticRenderFns } from "./comments-grid.vue?vue&type=template&id=75b58a92&scoped=true&"
import script from "./comments-grid.vue?vue&type=script&lang=ts&"
export * from "./comments-grid.vue?vue&type=script&lang=ts&"
import style0 from "./comments-grid.vue?vue&type=style&index=0&id=75b58a92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b58a92",
  null
  
)

export default component.exports